import React, { useState, useCallback, useRef, useEffect } from 'react';
import { format, subDays } from 'date-fns';

const OmniSearch: React.FC = () => {
  const [searchString, setSearchString] = useState<string>('');
  const [showClear, setShowClear] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('q')) {
      setSearchString(queryParams.get('q') ?? '');
    }
  }, [])

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFocus = () => {
    setTimeout(() => inputRef?.current?.value && setShowClear(true), 100); // Show the clear button on focus
  };

  const handleBlur = () => {
    setTimeout(() => setShowClear(false), 100); // Hide the clear button on focus out
  };

  useEffect(() => {
    if (inputRef?.current?.value) {
      setShowClear(true);
    }
  }, [inputRef?.current?.value]);

  const handleKeyPress = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (inputRef?.current?.value) {
        event.currentTarget.form?.submit();
      }
    }
  }, []);

  const handleSearchClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    if (inputRef?.current?.value) {
      inputRef?.current?.form?.submit();
    }
  }, []);

  const handleClearClick = useCallback(() => {
    setSearchString('');
    setShowClear(false);
  }, []);

  const startDate = format(subDays(new Date(), 7), 'yyyy-MM-dd');

  return (
    <div className="col-xs-12 col-sm-3 col-md-5 col-lg-5 omni-search">
      <form action="/trips/search" method="GET">
        <input
          type="text"
          ref={inputRef}
          autoSave="searchTermsCache"
          className="form-control search-box"
          name="q"
          onFocus={handleFocus} // Show clear button on focus
          onBlur={handleBlur} // Hide clear button on focus out
          onKeyPress={handleKeyPress}
          value={searchString}
          onChange={event => setSearchString(event.target.value ?? '')}
        />
        <input type="hidden" name="dateoftravelbegin" value={startDate} />
      </form>
      {showClear && <i
        className="clear-field ng-scope ng-hide"
        onClick={handleClearClick}
        aria-label="Clear search field"
      >
        <span className="glyphicon glyphicon-remove-circle"></span>
      </i>}
      <i
        className="search-icon ng-scope"
        onClick={handleSearchClick}
        aria-label="Search"
      >
        <span className="glyphicon glyphicon-search"></span>
      </i>
    </div>
  );
};

export default OmniSearch;